import ReactDOM from "react-dom";
import {ConfirmDialog} from "./ConfirmDialog";

/**
 * @template R
 * @typedef {JSXElementConstructor<{ onClose: (result: R) => void }>} CloseableComponent<R>
 * */

export const ModalManager = {

    /**
     * Open modal dialog and wait for close
     * WARNING: it will replace onClose parameter if you pass any
     * @template T
     * @param {JSX.Element<any, CloseableComponent<T>>} component
     * @return {Promise<T>}
     * */
    open(component){
        let node = document.querySelector('div[data-modal-manager]');
        if (node == null) {
            node = document.createElement('div');
            node.dataset.modalManager = 'true';
            document.body.appendChild(node);
        }
        return new Promise((res, rej) => {
            const onClose = function (result) {
                ReactDOM.unmountComponentAtNode(node)
                res(result);
            };
            const props = {...component.props, onClose };
            ReactDOM.render(<component.type {...props} />, node);
        });
    },

    /**
     * @param {string} title
     * @param {string} question
     * @return {Promise<boolean>}
     * */
    confirm(title, question) {
        return ModalManager.open(<ConfirmDialog title={title} question={question} />);
    }
}
